import { Box, Typography } from '@mui/material';
import React from 'react';
import { ReviewEmptyStateCopy } from './reviewEmptyState';

const ReviewFilterEmptyState: React.FC<ReviewEmptyStateCopy> = ({ title, hint }) => (
  <Box sx={{ pt: 2, px: 2, textAlign: 'center' }}>
    <Typography color="text.secondary">{title}</Typography>
    {hint ? (
      <Typography color="text.secondary" variant="body2" sx={{ mt: 0.75 }}>
        {hint}
      </Typography>
    ) : null}
  </Box>
);

export default ReviewFilterEmptyState;
